import { render } from "./SpecialRequestModal.vue?vue&type=template&id=04c4045e"
import script from "./SpecialRequestModal.vue?vue&type=script&lang=js"
export * from "./SpecialRequestModal.vue?vue&type=script&lang=js"

import "./SpecialRequestModal.vue?vue&type=style&index=0&id=04c4045e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__